import React from 'react';
import { Col, ListGroupItem, Row } from 'reactstrap';

export const NewLeadAddedNotify = ({ data, type, onClientRedirect, index, removeNotificationAndClose }) => {

    const onNotificationClick = (e, data) => {
        e.preventDefault();
        onClientRedirect(data.clientReference, index, data, type);
    }

    const onCloseHanlder = (e) => {
        e.preventDefault();
        removeNotificationAndClose(index, true);
    }

    return <ListGroupItem key={index}
        className="list-group-item-action">
        <Row className="align-items-center">
            <Col md="11" className="pr-1">
                <a className="list-group-item-action" href="#item" onClick={e => onNotificationClick(e, data)}>
                    <p className="text-sm mb-0"> New Lead. Name: <span className="h5">{data.firstName + ' ' + data.lastName}</span>, ClientID: <span className="h5">{data.clientId}</span>,
                    Affiliate: <span className="h5">{data.affiliateName}</span>. Click here to open client.</p>
                </a>

            </Col>
            <Col md="1" className="pl-0">
                <a href="#delelte" onClick={e => onCloseHanlder(e)}>
                    <i className="ni ni-fat-remove"></i>
                </a>
            </Col>
        </Row>
    </ListGroupItem>;    
};